export default __webpack_public_path__ + "static/media/signature.e940d4a6.png";